module.exports = __webpack_public_path__ + "static/img/KO.738d6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/h5/KO.png
// module id = i6qD
// module chunks = 1